import { types } from "mobx-state-tree";
import * as actions from './singleNotificationActions';
import * as views from './singleNotificationViews';
import Coupon from "../../models/coupon/coupon";
import Merchant from "../../models/merchant/Merchant";

const SingleNotificationStore = types
  .model('SingleNotificationStore', {
    selectedCoupon: types.maybeNull(
      types.reference(Coupon)
    ),

    title: types.maybeNull(types.string),
    text: types.maybeNull(types.string),
    type: types.optional(types.string, "PROMOTION"),
      
    titleError: types.maybeNull(types.string),
    textError: types.maybeNull(types.string),
    selectedCouponError: types.maybeNull(types.string),

    selectedMerchant: types.maybeNull(types.reference(Merchant)),
    pastDayOnly: false,

    loading: false,
  })
  .views(views.singleNotificationViews)
  .actions(actions.singleNotificationActions);

export default SingleNotificationStore;


